export const TESTIDS = {
  landing: {
    getStartedBtn: "landing-get-started-btn",
    loginBtn: "landing-login-btn",
    pricingCta: "landing-pricing-cta",
    themeToggle: "theme-toggle",
  },
  auth: {
    emailInput: "auth-email-input",
    passwordInput: "auth-password-input",
    nameInput: "auth-name-input",
    workspaceInput: "auth-workspace-input",
    submitBtn: "auth-submit-btn",
    googleBtn: "auth-google-btn",
    switchToSignup: "auth-switch-to-signup",
    switchToLogin: "auth-switch-to-login",
  },
  shell: {
    sidebar: "app-sidebar",
    userMenu: "app-user-menu",
    logoutBtn: "app-logout-btn",
    workspaceSwitcher: "app-workspace-switcher",
    commandPaletteBtn: "app-command-palette-btn",
  },
  dashboard: {
    revenueCard: "dashboard-revenue-card",
    ordersCard: "dashboard-orders-card",
    productsCard: "dashboard-products-card",
    lowStockCard: "dashboard-low-stock-card",
  },
  inventory: {
    addProductBtn: "inventory-add-product-btn",
    saveProductBtn: "inventory-save-product-btn",
    searchInput: "inventory-search-input",
    tabProducts: "inventory-tab-products",
    tabCategories: "inventory-tab-categories",
    tabBrands: "inventory-tab-brands",
    tabUnits: "inventory-tab-units",
    tabWarehouses: "inventory-tab-warehouses",
    tabSuppliers: "inventory-tab-suppliers",
    tabMovements: "inventory-tab-movements",
    tabTransfers: "inventory-tab-transfers",
    tabAdjustments: "inventory-tab-adjustments",
    tabCounts: "inventory-tab-counts",
    tabImportExport: "inventory-tab-importexport",
  },
  pos: {
    addToCart: "pos-add-to-cart",
    checkoutBtn: "pos-checkout-btn",
    clearCartBtn: "pos-clear-cart-btn",
  },
  invoice: {
    createBtn: "invoice-create-btn",
    saveBtn: "invoice-save-btn",
  },
  billing: {
    upgradeBtn: "billing-upgrade-btn",
  },
};
export const HOME = { emergentLink: "landing-get-started-btn" };
